<template>
<div class=page_content>
  <menulist></menulist>
  <router-view/>
</div>
</template>

<script>
import menulist from './menulist.vue'

export default {
  components: {
    menulist
  }
}
</script>
<style scoped>
.page_content {
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/careRingsMaster.vue